import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { FilterOutlined } from "@ant-design/icons";
import { DatePicker as AntdDatePicker, Row, Select, Space } from "antd";
import { Button } from "components/elements";
import MyTeamManageShiftTable from "components/table/MyTeamManageShiftTable";

function MyTeamManageShift({
  isLoading = false,
  selectedMode = null,
  manageShiftList = [],
  onFilter = () => {},
  onExport = () => {},
  onSwapShift = () => {},
  onModeChange = () => {},
  onChangeShift = () => {},
  onEndDateChange = () => {},
  onStartDateChange = () => {},
}) {
  const { t } = useTranslation();

  return (
    <Space style={{ width: "100%" }} size={24} direction="vertical">
      <Row justify="space-between">
        <Space size={12}>
          <Select
            value={selectedMode}
            defaultValue={selectedMode}
            onChange={onModeChange}
            style={{ width: 120 }}
            options={[
              {
                label: t("unit.week"),
                value: "week",
              },
              {
                label: t("unit.month"),
                value: "month",
              },
            ]}
            size="large"
          />
          <AntdDatePicker
            defaultValue={dayjs()}
            onChange={onStartDateChange}
            size="large"
          />
          <span>-</span>
          <AntdDatePicker
            defaultValue={dayjs()}
            onChange={onEndDateChange}
            size="large"
          />
        </Space>
        <Space size={12}>
          <Button type="default" onClick={onFilter} size="large">
            {t("common.filter")} <FilterOutlined />
          </Button>

          <Button type="default" onClick={onExport} size="large">
            {t("common.export")}
          </Button>
          <Button onClick={onChangeShift} size="large">
            Change Shift
          </Button>
          <Button onClick={onSwapShift} size="large">
            Swap Shift
          </Button>
        </Space>
      </Row>
      <MyTeamManageShiftTable
        isLoading={isLoading}
        dataSource={manageShiftList}
      />
    </Space>
  );
}

export default MyTeamManageShift;
